// config
import * as http from 'utils/http';
import config from 'config';

const createNewQuote = async ({ quoteDto, ticketId }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/`, quoteDto);
};

export default createNewQuote;
